import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND } from "@/constants/brand";

const NAV = [
  { to: "/requested-products", label: "Wishlist" },
  { to: "/track-request", label: "Track Request" },
  { to: "/worlds", label: "Worlds" },
  { to: "/flavour-creator", label: "Invent" },
  { to: "/flavour-lab", label: "Flavour Lab" },
  { to: "/journey", label: "Journey" },
  { to: "/challenges", label: "Challenges" },
  { to: "/hall-of-fame", label: "Hall of Fame" },
  { to: "/contributors", label: "Contributors" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header data-testid="site-navbar" className="sticky top-0 z-40 bg-[#FFF8F0]/85 backdrop-blur-md border-b border-brand-line">
      <div className="container-pp flex items-center justify-between px-6 py-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src={BRAND.logoUrl} alt="Pop Panda" className="h-10 w-10 object-contain" />
          <div className="leading-none">
            <div className="font-display text-2xl tracking-tight">Pop Panda</div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-brand-charcoal/60">{BRAND.tagline}</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace("/", "")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${isActive ? "text-brand-charcoal" : "text-brand-charcoal/65 hover:text-brand-charcoal"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/scratch/main" data-testid="nav-pay" className="btn-pill text-xs inline-flex items-center gap-1.5 text-[#1a0f2f] font-semibold" style={{ background: "linear-gradient(135deg, #FFE07A 0%, #FFC93C 60%, #E5A100 100%)", boxShadow: "0 6px 18px rgba(255,201,60,0.35)" }}>Pay at Store</Link>
          <Link to="/member/spin" data-testid="nav-spin" className="btn-pill btn-ghost text-xs">Spin & Win</Link>
          <Link to="/member/login" data-testid="nav-member" className="btn-pill btn-ghost text-xs">Panda Club</Link>
          <Link to="/admin/login" data-testid="nav-admin" className="btn-pill btn-ghost text-xs">Admin</Link>
          <Link to="/flavour-creator" data-testid="nav-cta-design" className="btn-pill btn-dark text-xs">
            Create Your Own Popsicle
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile" className="lg:hidden border-t border-brand-line bg-[#FFF8F0]">
          <div className="container-pp px-6 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-m-${n.to.replace("/", "")}`}
                className="text-base text-brand-charcoal/80 hover:text-brand-charcoal"
              >
                {n.label}
              </Link>
            ))}
            <Link to="/member/login" data-testid="nav-m-member" className="text-base text-brand-charcoal/80">Panda Club</Link>
            <Link to="/admin/login" data-testid="nav-m-admin" className="text-base text-brand-charcoal/80">Admin</Link>
            <Link to="/scratch/main" data-testid="nav-m-pay" className="btn-pill mt-2 w-fit text-xs text-[#1a0f2f] font-semibold" style={{ background: "linear-gradient(135deg, #FFE07A 0%, #FFC93C 60%, #E5A100 100%)" }}>Pay at Store</Link>
            <Link to="/flavour-creator" data-testid="nav-m-cta" className="btn-pill btn-dark mt-2 w-fit text-xs">
              Create Your Own Popsicle
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
